module.exports = __webpack_public_path__ + "img/Shonin.446b715e.png";